import { gql } from "@apollo/client";

export const GET_RECORD_POINT_TREES = gql`
  query GetRecordPointTrees($branchId: Int!) {
    recordPointTrees(branchId: $branchId) {
      recordPointTreeId
      createdAt
      updatedAt
      status
      name
      parent
      orderNumber
    }
  }
`;

export const CREATE_RECORD_POINT_TREE = gql`
  mutation CreateRecordPointTree(
    $name: String!
    $orderNumber: Int!
    $branchId: Int!
    $parent: String
  ) {
    createRecordPointTree(
      name: $name
      orderNumber: $orderNumber
      branchId: $branchId
      parent: $parent
    ) {
      recordPointTreeId
      createdAt
      updatedAt
      status
      name
      parent
      orderNumber
    }
  }
`;

export const UPDATE_RECORD_POINT_TREE = gql`
  mutation UpdateRecordPointTree(
    $recordPointTreeId: Int!
    $name: String
    $orderNumber: Int
    $parent: String
  ) {
    updateRecordPointTree(
      recordPointTreeId: $recordPointTreeId
      name: $name
      orderNumber: $orderNumber
      parent: $parent
    ) {
      recordPointTreeId
      createdAt
      updatedAt
      status
      name
      parent
      orderNumber
    }
  }
`;

export const DELETE_RECORD_POINT_TREE = gql`
  mutation DeleteRecordPointTree($recordPointTreeId: Int!) {
    deleteRecordPointTree(recordPointTreeId: $recordPointTreeId)
  }
`;
